export default __webpack_public_path__ + "static/media/Detect-Vulnerabillity-pentest.5a8545eb.svg";